import localforage from 'localforage'

export const getUserContextItem = async ({ key }: { key: string }) => {
  return await localforage.getItem(`user_context.${key}`);
}

export const setUserContextItem = async ({ key, value }: { key: string, value: any }) => {
  await localforage.setItem(`user_context.${key}`, value);
  return true
}

export const removeUserContextItem = async ({ key }: { key: string }) => {
  return await localforage.removeItem(`user_context.${key}`);
}

export const getUserContexts = async () => {
  const debug_mode = await getUserContextItem({ key: 'debug_mode' });
  const ga4_id = await getUserContextItem({ key: 'ga4_id' });
  const ua_id = await getUserContextItem({ key: 'ua_id' });
  const tag_manager_id = await getUserContextItem({ key: 'tag_manger_id' });
  const optimize_id = await getUserContextItem({ key: 'optimize_id' });
  const user_id = await getUserContextItem({ key: 'user_id' });

  return { debug_mode, ga4_id, ua_id, tag_manager_id, optimize_id, user_id }
}

export const removeUserContexts = async () => {
  await removeUserContextItem({ key: 'debug_mode' });
  await removeUserContextItem({ key: 'ga4_id' });
  await removeUserContextItem({ key: 'ua_id' });
  await removeUserContextItem({ key: 'tag_manger_id' });
  await removeUserContextItem({ key: 'optimize_id' });
  await removeUserContextItem({ key: 'user_id' });
}